const auth = {
  user: {
    authenticated: false,
  },

  loggedIn() {
    if (localStorage.getItem('token')) {
      return true;
    }
    return false;
  },

  logout() {
    console.log('Logging user out!');
    localStorage.removeItem('token');
    auth.user.authenticated = false;
  },

  getToken() {
    return localStorage.getItem('token');
  },
};

export default auth;
